














import Vue from "vue";
import CreateEditCard from "./CreateEditCard.vue";
import ZenyaDialog from "../../../components/dialogs/ZenyaDialog.vue";
export default Vue.extend({
    name: "NewsArticleCreateEdit",
    components: { CreateEditCard, ZenyaDialog },
    props: {
        value: { type: Boolean, required: true },
        id: { type: Number },
        currentPortalId: Number
    }
});
